import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { restartableTask, timeout } from 'ember-concurrency';
import { STORAGE_KEYS } from 'sh-www/services/local-storage-fallback';

class EndMasqueradeRoute extends Route {
  @service auth;
  @service session;
  @service('local-storage-fallback') storage;
  @service('error-tracker') errorTracker;

  activate() {
    this.endMasquerade.perform();
  }

  @restartableTask
  *endMasquerade() {
    yield timeout(1);

    try {
      yield this.auth.unMasquerade.perform();
    } catch (e) {
      this.errorTracker.error(e, this);
    }
  }
}

export default EndMasqueradeRoute;
